import React, { useEffect } from "react";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import Carousel from "./Carousel";
import Filters from "./Filters";
import { Helmet } from "react-helmet";
const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // window.location.replace(routes.HOME);
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="Filter Manufacturer in India, Automotive filters in India"/>

        <meta
          name="description"
          content="Discover high-quality automotive filters that deliver superior performance and unmatched reliability. Our ISO-certified manufacturing processes ensure top-notch filtration solutions for your vehicles. Explore our wide range of filters today"
        />
      </Helmet>
      <Header />
      <Carousel />
      <Filters />
      <Footer />
    </>
  );
};
export default Home;
